import { render, staticRenderFns } from "./LeadFunnelStepBirthday.vue?vue&type=template&id=99817170&"
import script from "./LeadFunnelStepBirthday.vue?vue&type=script&lang=js&"
export * from "./LeadFunnelStepBirthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports